/* unplugin-vue-components disabled */import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/QsyFileUpload.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "mine-cell",
    class: {
      border: !_vm.hiddenBorder
    }
  }, [!_vm.hasTitleSlot ? _c('div', [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm.hasTitleSlot ? _c('div', [_vm._t("title")], 2) : _vm._e(), _c('div', {
    staticClass: "upload"
  }, [_vm._l(_vm.currValue, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "upload-list",
      on: {
        "click": function ($event) {
          return _vm.imgClick(index);
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item
      }
    }), !_vm.hiddenDelete ? _c('div', {
      staticClass: "upload-list-delete",
      on: {
        "click": function ($event) {
          return _vm.deleteImg(index);
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": "/spa_static_mobile/icon/deletepic28_28@3x.png"
      }
    })]) : _vm._e()]);
  }), !_vm.hiddenUpload ? _c('div', {
    staticClass: "upload-list upload-btn"
  }, [_vm.isUpperLimit ? _c('div', {
    staticClass: "file-input limit",
    on: {
      "click": _vm.clickUpload
    }
  }) : _vm._e(), _c(__unplugin_components_0, {
    ref: "qsyFileUpload",
    staticClass: "file-input",
    attrs: {
      "target": "/upload/save",
      "action": "POST",
      "waterMask": _vm.waterMask,
      "accept": ['image/*']
    },
    on: {
      "start": function ($event) {
        _vm.loadingShow = true;
      },
      "finish": _vm.finish,
      "progress": function ($event) {
        _vm.progress = $event;
      }
    }
  }), _vm._m(0)], 1) : _vm._e(), _c('Previewer', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    ref: "previewer",
    attrs: {
      "list": _vm.imgUrlsForPreviewer
    }
  })], 2), _c('Loading', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    attrs: {
      "text": _vm.progress + '%'
    },
    model: {
      value: _vm.loadingShow,
      callback: function ($$v) {
        _vm.loadingShow = $$v;
      },
      expression: "loadingShow"
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "default-add"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/addpic40_40@3x.png"
    }
  })]);
}];
export { render, staticRenderFns };